import { Card, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
const CardComp = ({ movie }) => {
  return (
    <Col sm={12} md={6} lg={4} xl={3} className="my-2">
      <Link to={`/movie/${movie.id}`}>
        <Card
          style={{
            position: "relative",
            height: "50vh",
            zIndex: 1,
            cursor: "pointer",
          }}
          className="card"
        >
          <Card.Img
            src={`https://image.tmdb.org/t/p/w500/${movie.poster_path}`}
            style={{ height: "100%" }}
          />
          <div
            style={{
              backgroundColor: "#393839",
              position: "absolute",
              left: 0,
              top: 0,
              cursor: "pointer",
              zIndex: 2,
              width: "100%",
              height: "100%",
            }}
            className="secondCard"
          >
            <div className="d-flex justify-content-center w-100 h-100 align-items-center">
              <div className="text-center text-white">
                <p
                  className="fs-5 lead text-white"
                  style={{ fontWeight: "bold" }}
                >
                  الفيلم: {movie.original_title}
                </p>
                <p
                  className="fs-5 lead text-white"
                  style={{ fontWeight: "bold" }}
                >
                  تاريخ الاصدار: {movie.release_date}
                </p>
                <p
                  className="fs-5 lead text-white"
                  style={{ fontWeight: "bold" }}
                >
                  عدد المقيمين: {movie.vote_count}
                </p>
                <p
                  className="fs-5 lead text-white"
                  style={{ fontWeight: "bold" }}
                >
                  التقييم:{movie.vote_average}
                </p>
              </div>
            </div>
          </div>
        </Card>
      </Link>
    </Col>
  );
};

export default CardComp;
